import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyC0vH6AUKBmWP2lMVvZi3_nv4LxbFqjXCE",
  authDomain: "slack-clone-1c1ea.firebaseapp.com",
  databaseURL: "https://slack-clone-1c1ea.firebaseio.com",
  projectId: "slack-clone-1c1ea",
  storageBucket: "slack-clone-1c1ea.appspot.com",
  messagingSenderId: "40314805867",
  appId: "1:40314805867:web:8c4eb6c6c631b4e5135b2e",
  measurementId: "G-8DMJKHJMEQ",
};

// Connect app to firebase
const firebaseApp = firebase.initializeApp(firebaseConfig);
// db acces to database
const db = firebaseApp.firestore();
// For login auth (authetication module)
const auth = firebase.auth();
// Get google services
const provider = new firebase.auth.GoogleAuthProvider();

export { auth, provider };
export default db;
